module.exports = __webpack_public_path__ + "static/img/Send13.e7963a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send13.png
// module id = qXeb
// module chunks = 0